define('all/ie-unload-flash',['jquery'], function($) {
	'use strict';
	$(window).unload(function unloadFlashForIE() {
		// Removing all flash objects to prevent white flashes in IE
		$('object').remove();
	});
});

